//десктопная сетка хранит colId вида 'status.name', а мобильные списки работают с ключами attributes без точек
const mobileColumnIdMap = {
    'status.name': 'status',
    'status.id': 'status_id',
    'office.name': 'office',
    'office.id': 'office_id',
    'responsible_user.full_name': 'responsible_user',
    'responsible_user.id': 'responsible_user_id',
    'contact.name': 'contact_name',
    'contact.phone': 'contact_phone',
    'contact.email': 'contact_email',
    'contact.id': 'contact_id',
    'link.name': 'link',
    'link.id': 'link_id'
};

export function toMobileColumnId(colId) {
    return mobileColumnIdMap[colId] || colId;
}
